"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldType = exports.Certification = void 0;
var Certification;
(function (Certification) {
    Certification["ce"] = "ce";
    Certification["ukCa"] = "ukCa";
})(Certification = exports.Certification || (exports.Certification = {}));
var FormFieldType;
(function (FormFieldType) {
    FormFieldType["area"] = "area";
    FormFieldType["long"] = "long";
    FormFieldType["full"] = "full";
    FormFieldType["date"] = "date";
    FormFieldType["input"] = "input";
    FormFieldType["radio"] = "radio";
    FormFieldType["short"] = "short";
    FormFieldType["check"] = "check";
    FormFieldType["picto"] = "picto";
    FormFieldType["select"] = "select";
    FormFieldType["upload"] = "upload";
    FormFieldType["editor"] = "editor";
    FormFieldType["multiSelect"] = "multiSelect";
    FormFieldType["countrySelect"] = "countrySelect";
    FormFieldType["standardsSelect"] = "standardsSelect";
    FormFieldType["manufacturerSelect"] = "manufacturerSelect";
    FormFieldType["informational"] = "informational";
})(FormFieldType = exports.FormFieldType || (exports.FormFieldType = {}));
